'use client';

import { Cookie } from 'lucide-react';

/**
 * Botón en el footer que re-abre el modal CMP. El modal vive en
 * <ConsentBanner /> que escucha el evento global `nqoro:openCmp`.
 */
export function CookiePreferencesButton() {
  return (
    <div>
      <p className="type-eyebrow mb-4 text-[var(--color-fg-subtle)]">Privacidad</p>
      <ul className="flex flex-col gap-2">
        <li>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event('nqoro:openCmp'))}
            className="type-body-sm inline-flex items-center gap-2 text-left transition-colors hover:text-[var(--color-accent)]"
          >
            <Cookie className="h-3.5 w-3.5" />
            Preferencias de cookies
          </button>
        </li>
        <li>
          <a
            href="/cuenta/privacidad"
            className="type-body-sm transition-colors hover:text-[var(--color-accent)]"
          >
            Derechos ARCO
          </a>
        </li>
      </ul>
    </div>
  );
}
